export { default } from './SearchTags';
